<app-footer-top/>
<app-footer-newsletter/>
<app-footer-our-stores/>
<app-footer-info-and-links/>
<app-footer-bottom/>

<div class="footer-bottom" data-rr-shared="true">
  <div class="container">
    <p class="footer-text" i18n>SUPERVIN, HJØRRING A/S</p>
    <p class="footer-text hide-element-on-mobile" i18n>Skagensvej 201</p>
    <p class="footer-text hide-element-on-mobile" i18n>9800 Hjørring, Danmark</p>
    <p class="footer-text hide-element-on-mobile" i18n> Tlf. +4598921853</p>
    <p class="footer-text hide-element-on-mobile">
      <a href="mailto:info@supervin.dk" i18n i18n-href>info&#64;supervin.dk</a>
    </p>
    <p class="footer-text" i18n>CVR 21281573</p>
    @if (isSwedishWebsite) {
      <p class="footer-text" i18n>SE Alkohollicens 54 3139815</p>
    } @else {
      <a href="https://www.findsmiley.dk/23815" target="_blank">
            <span class="footer-text">
              <img ngSrc='https://a.storyblok.com/f/106593/99x32/307796f795/banner_gul_99x32.gif' height="32"
                   style="width: 99px; height: 32px;"
                   width="99">
            </span>
      </a>
    }
  </div>
</div>
